export default {
  ROUNDTRIP_CHECK: 'ott/railways/roundtripCheck',
  ROUNDTRIP_CHECK_SUCCESS: 'ott/railways/roundtripCheckSuccess',
  ROUNDTRIP_CHECK_FAIL: 'ott/railways/roundtripCheckFail',
};
